module.exports = __webpack_public_path__ + "static/media/blog1.f9969177.jpg";